import { IQueryTypeFragments } from 'src/api/QueryFragments';
import { serviceNames, diContainer } from '../../service-setup/diContainer';
import { ProductRepository } from '../repositories/ProductRepository';

export class ProductLoadedUseCase {
    private productRepository: ProductRepository;
    private productId: string;
    private queryFragments: IQueryTypeFragments;

    constructor(productId: string, queryFragments: IQueryTypeFragments) {
        this.productId = productId;
        this.queryFragments = queryFragments;
        this.productRepository = diContainer.get(serviceNames.productRepository);
    }

    public execute = async () => {
        await this.productRepository.retrieveProductById(
            this.productId,
            false,
            this.queryFragments
        );
    };
}
